import { render } from "./OverlayView.vue?vue&type=template&id=2b3a3304"
import script from "./OverlayView.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./OverlayView.vue?vue&type=script&charset=utf-8&lang=js"

import "./OverlayView.vue?vue&type=style&index=0&id=2b3a3304&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__